<section *ngFor="let product of products$ | async; let $index = index">
  <bca-product
    [company]="company$ | async"
    [product]="product"
    [totalProductCount]="totalProductCount$ | async"
    [productNumber]="$index + 1"
    (delete)="onProductDelete($event)"
    (deleteAddon)="onAddonDelete($event, product.id)"
    (edit)="onProductEdit($event)"
    (editUser)="onUserEdit($event)"
  >
  </bca-product>
</section>
